import React from 'react'
import styles from './style.module.css'
import { BsArrowRight } from "react-icons/bs";
import { CiCalendar } from "react-icons/ci";
import { BsCurrencyDollar } from "react-icons/bs";
import { LuShield } from "react-icons/lu";
import { RxLightningBolt } from "react-icons/rx";
import { LuPiggyBank } from "react-icons/lu";
import { Link } from 'react-router-dom';

const Home_1 = () => {

    const scrollToTop = () => {
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 200);
    };

    return (

        <div className={`container d-flex align-items-center ${styles['home-1-container']}`}>
            <div className={styles['home-1-sub1-contatiner']}>
                <div className={styles['home-1-sub1']}>
                    <div>
                        <h1 className={styles['home-1-sub1-header']}>
                            Reserve, Charge, BreatheEV
                        </h1>
                        <div className={styles['home-1-sub1-para']}>
                            BreatheEV provides turnkey EV charging solutions with minimal upfront investment. Reserve a charging spot in advance or monetize your property, we make EV charging effortless.
                        </div>
                        <div className={styles['home-1-sub1-buttons-container']}>
                            <Link target='_blank' to={'https://app.breathe-ev.com'} className={styles['home-1-sub1-button']}>
                                Start Charging
                            </Link>
                            <Link onClick={scrollToTop} to={'/partner-with-us'} className={styles['home-1-sub1-button']}>
                                Partner With Us <BsArrowRight />
                            </Link>
                        </div>
                    </div>
                    <div>
                        <div className={styles['home-1-sub1-facts-container']}>
                            <div className={styles['home-1-sub1-facts']}>
                                <div className={styles['home-1-sub1-facts-header']}>99%</div>
                                <div className={styles['home-1-sub1-facts-para']}>Uptime</div>

                            </div>
                            <div className={styles['home-1-sub1-facts']}>
                                <div className={styles['home-1-sub1-facts-header']}>50</div>
                                <div className={styles['home-1-sub1-facts-para']}>States covered</div>
                            </div>
                            <div className={styles['home-1-sub1-facts']}>
                                <div className={styles['home-1-sub1-facts-header']}>24/7</div>
                                <div className={styles['home-1-sub1-facts-para']}>Monitoring</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles['home-1-sub2-container']}>
                <div className={styles['home-1-sub2-inner']}>
                    <div className={styles['home-1-sub2-inner-right']}>
                        <div className={styles['home-1-sub2-inner-ext-icon']}>
                            <RxLightningBolt />
                        </div>
                        <div>
                            <span className={styles['home-1-sub2-inner-ext-heading']}>
                                Unlock Revenue
                            </span><br />
                            <span className={styles['home-1-sub2-inner-ext-para']}>
                                Boost Profits
                            </span>
                        </div>
                    </div>
                    <div className={styles['home-1-sub2-inner-container']}>
                        <div className={styles['home-1-sub2-inner-icon']}>
                            <CiCalendar />
                        </div>
                        <div>
                            <span className={styles['home-1-sub2-inner-heading']}>
                                Reservation-Based
                            </span><br />
                            <div className={styles['home-1-sub2-inner-para']}>
                                Eliminate wait times with scheduled charging
                            </div>
                        </div>
                    </div>
                    <div className={styles['home-1-sub2-inner-container']}>
                        <div className={styles['home-1-sub2-inner-icon']}>
                            <BsCurrencyDollar />
                        </div>
                        <div>
                            <span className={styles['home-1-sub2-inner-heading']}>
                                Flexible Cost Models
                            </span><br />
                            <div className={styles['home-1-sub2-inner-para']}>
                                Start with little to no upfront costs
                            </div>
                        </div>
                    </div>
                    <div className={styles['home-1-sub2-inner-container']}>
                        <div className={styles['home-1-sub2-inner-icon']}>
                            <LuShield />
                        </div>
                        <div>
                            <span className={styles['home-1-sub2-inner-heading']}>
                                Fully Managed
                            </span><br />
                            <div className={styles['home-1-sub2-inner-para']}>
                                Hands-off operation and maintenance
                            </div>
                        </div>
                    </div>

                    <div className={styles['home-1-sub2-inner-left']}>
                        <div className={styles['home-1-sub2-inner-ext-icon']}>
                            <LuPiggyBank />
                        </div>
                        <div>
                            <span className={styles['home-1-sub2-inner-ext-heading']}>
                                Minimal Investment
                            </span><br />
                            <span className={styles['home-1-sub2-inner-ext-para']}>
                                Fast ROI
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        //   </div>
    )
}

export default Home_1